import { useState, useCallback, useEffect } from "react";
import { useAuthedRequest } from "shared/@auth/Auth";
import { useLogger } from "shared/@hooks/useLogger";
import { RequestCache } from "shared/@hooks/useRequestCache";

export function useTransactions({ iboNumber, page = 0, limit = 25 }) {
  const { logError } = useLogger({ prefix: "useTransactions" });
  const [requestId, setRequestId] = useState(0);
  const [records, setRecords] = useState(null);
  const cache = RequestCache.useContainer();
  const { data, loading, error } = useAuthedRequest(
    `/v1/membership/transactions/${iboNumber}/cc/?limit=${limit}&page=${page}&req=${requestId}`,
    null,
    cache
  );

  // Prevent records from becoming null between refreshes.
  useEffect(() => {
    if (data != null) {
      setRecords(data);
    }
  }, [data]);

  const refresh = useCallback(() => {
    setRequestId(requestId + 1);
  }, [requestId]);

  return {
    records,
    loading,
    refresh,
  };
}
